import { render, staticRenderFns } from "./sizeManagement.vue?vue&type=template&id=11ce1992&"
import script from "./sizeManagement.vue?vue&type=script&lang=js&"
export * from "./sizeManagement.vue?vue&type=script&lang=js&"
import style0 from "./sizeManagement.vue?vue&type=style&index=0&id=11ce1992&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports